import { render, staticRenderFns } from "./Vegas_New.vue?vue&type=template&id=7fac2c18&scoped=true"
import script from "./Vegas_New.vue?vue&type=script&lang=js"
export * from "./Vegas_New.vue?vue&type=script&lang=js"
import style0 from "./Vegas_New.vue?vue&type=style&index=0&id=7fac2c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac2c18",
  null
  
)

export default component.exports